import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(private apiService: ApiService) { }

  getExpenses(queryParams: HttpParams) {
    return this.apiService.get('expenses', queryParams)
  }

  createExpense(data: any) {
    return this.apiService.post('expenses', data);
  }

  getExpense(id: any) {
    return this.apiService.get('expenses/' + id);
  }

  updateExpense(id: any, data: any) {
    // If it's FormData, we usually use POST with _method spoofing for Laravel multipart updates
    if (data instanceof FormData) {
      return this.apiService.post('expenses/' + id, data);
    }
    return this.apiService.update('expenses/' + id, data);
  }

  deleteExpense(id: any) {
    return this.apiService.delete('expenses/' + id)
  }

  getExpenseAnalytics(queryParams: HttpParams) {
    return this.apiService.get('expenses/analytics', queryParams);
  }
}
